<script setup lang="ts">
  import StoreMenuItemAllergens from '@/components/shared/StoreMenuItemAllergens.vue';
  import StoreMenuItemPicture from '@/components/shared/StoreMenuItemPicture.vue';
  import StoreMenuItemPrice from '@/components/shared/StoreMenuItemPrice.vue';
  import { IItem } from '@/interfaces/IItem';
  import { computed } from 'vue';

  const props = defineProps<{
    item: IItem;
    vertical?: boolean;
  }>();

  const itemClasses = computed(() => {
    return [
      ...(props.vertical ? ['vertical'] : []),
      ...(props.item.allergens ? ['has-allergens'] : []),
    ];
  });

  const hasDiscount = computed(
    () =>
      typeof props.item.discountedPrice !== 'undefined' &&
      props.item.discountedPrice !== null &&
      props.item.discountedPrice !== props.item.price
  );

  const discountPercentage = computed(() => {
    if (!hasDiscount.value) return 0;

    return Math.floor(
      100 - (props.item.discountedPrice! * 100) / props.item.price
    );
  });
</script>

<template>
  <div class="store-menu-item" :class="itemClasses" @click="$emit('click')">
    <!-- <UBadge
      v-if="vertical && discountPercentage > 0"
      :color="restaurantStore.themeSettings.color"
      class="discount-badge"
      :label="`-${discountPercentage}%`"
      size="xs"
    /> -->
    <div v-if="item.picture || vertical" class="logo-container">
      <StoreMenuItemPicture :item="item" size="2xl" class="logo" />
    </div>
    <div class="item-content">
      <div class="name-container">
        <span class="name">{{ item.name }}</span>
      </div>
      <div class="description-container">
        <!-- <p v-if="!vertical && item.description" class="description">
          {{ item.description }}
        </p> -->
        <div v-if="!vertical && item.allergens" class="allergens-container">
          <StoreMenuItemAllergens :item="item" size="xs" :max="5" />
        </div>
      </div>
      <div class="footer">
        <StoreMenuItemPrice
          v-if="item.price > 0"
          class="price"
          :price="item.price"
          :discounted-price="item.discountedPrice"
          :has-options="item.hasOptions"
          :hide-discount-badge="vertical"
          :dense="true"
        />
        <div class="spacer"></div>
        <!-- <UButton
          v-if="menuStore.canOrder"
          icon="mdi-plus"
          :color="restaurantStore.themeSettings.color"
          size="sm"
          :ui="{ rounded: 'rounded-full' }"
          class="p-0.5"
        /> -->
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .store-menu-item {
    @apply tw-rounded-md tw-flex tw-items-start tw-space-x-2 tw-transition-all tw-cursor-pointer;
    height: 8rem;
    padding: 0.5rem 0.5rem;
    @apply tw-bg-white;

    @screen xs {
      height: 6.5rem;
    }

    &:hover {
      @apply tw-ring-orange-400 md:tw-ring-1;
    }

    .logo-container {
      @apply tw-flex-none;
      width: 4rem;
      height: 4rem;

      .logo {
        @apply tw-w-full tw-h-full tw-object-cover;
      }
    }

    .item-content {
      @apply tw-flex-1 tw-min-w-1 tw-space-y-1 tw-flex tw-flex-col tw-h-full tw-justify-between;

      .name-container {
        @apply tw-flex tw-flex-col tw-text-sm;
        line-height: 1.3em;

        .name {
          @apply tw-font-medium;
        }

        .original-name {
          @apply tw-text-gray-700 tw-text-gray-300 tw-text-sm tw-break-words tw--mt-0.5 tw-font-light;
        }
      }

      .description-container {
        @apply tw-min-h-1 tw-flex tw-flex-col tw-space-y-1 tw-overflow-hidden;

        .description {
          @apply tw-text-gray-600 tw-text-gray-400 tw-text-sm tw-font-light tw-line-clamp-2 md:tw-line-clamp-3 tw-break-words tw-min-h-0;
        }

        .allergens-container {
        }
      }

      .footer {
        @apply tw-flex tw-items-end tw-flex-1;

        .price {
        }
      }
    }

    &.has-allergens {
      .item-content {
        .description-container {
          .description {
            @apply tw-line-clamp-1 md:tw-line-clamp-2;
          }
        }
      }
    }

    &.vertical {
      @apply tw-flex-col tw-items-stretch tw-w-auto tw-gap-1 tw-h-auto tw-relative tw-rounded-lg;
      padding: 0.5rem;
      width: 9rem;

      @screen xs {
        padding: 0.75rem 0.5rem;
      }

      @screen sm {
        padding: 0.75rem;
        width: 9.5rem;
      }

      @screen md {
        width: 10.5rem;
      }

      .discount-badge {
        @apply tw-absolute tw-top-6 tw-right-0 tw-rounded-r-none;
      }

      .logo-container {
        width: 8rem;
        height: 6rem;

        @screen md {
          width: 9rem;
          height: 7rem;
        }
      }

      .item-content {
        @apply tw-space-y-0;

        .name-container {
          @apply tw-w-full;

          .name {
            @apply tw-block tw-text-xs tw-truncate;
          }

          .original-name {
          }
        }

        .footer {
          @apply tw-text-xs;
        }
      }
    }
  }
</style>
